export const center = (orientation) => {
  if (orientation === 'both') {
    return `
      display: flex;
      align-items: center;
      justify-content: center;
    `
  }

  if (orientation === 'vertical') {
    return `
      display: flex;
      align-items: center;
    `;
  }

  return `
    display: flex;
    justify-content: center;
  `;
 };
